class DigiLayer {
	constructor() {
		this.cart = {};
		this.wishlist = [];
		this.compares = [];
	}

	get cartState() {
		return this.cart;
	}

	addToCart(offer_id, amount = 1) {
		this.cart[offer_id] = (this.cart[offer_id] || 0) + amount;
		return Promise.resolve({ result: true });
	}

	removeFromCart(offer_id) {
		delete this.cart[offer_id];
		return Promise.resolve({ result: true });
	}

	get wishlistState() {
		return this.wishlist;
	}

	addToWishlist(offer_id) {
		if (!this.wishlist.includes(offer_id)) this.wishlist.push(offer_id);
		return Promise.resolve({ result: true });
	}

	removeFromWishlist(offer_id) {
		this.wishlist = this.wishlist.filter(id => id !== offer_id);
		return Promise.resolve({ result: true });
	}
}

window.digiLayer = new DigiLayer();
